import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        data: {
            type: Object,
            required: false,
            default: function () { return ({}); }
        }
    },
    methods: {
        renderText: function (content) {
            if (Array.isArray(content)) {
                return content.map(function (text, index) { return "<span>" + text + "</span> " + (index < content.length - 1 ? '<br/>' : ''); }).join('');
            }
            return content;
        },
        renderTable: function (content) {
            var keys = Object.keys(content) || '';
            var values = Object.values(content) || '';
            return {
                keys: keys,
                values: values
            };
        }
    }
});
